(function () {
  function init() {
window.__sideGuideSection = window.__sideGuideSection || null;


const page = document.querySelector(".page");
const cards = document.querySelectorAll("[data-case-card]");
const switchAreas = document.querySelectorAll("[data-switch-area]");
// bottom-meter は廃止 (HTML 削除済み)。これらは null。
// 残存コードは null チェック付きなのでそのまま動く。
const globalMeter = null;
const meterFill = null;
const meterFace = null;
const meterBalloon = null;

// 6-step palette: hiyari(青) → ほっと(赤) の方向。
// 0=最もひやり(深青) ... 5=最もほっと(赤)
const palette = ["#27a2e5", "#7aceff", "#acdeff", "#f9a5bb", "#ed728a", "#e03a3a"];

const stepForRatio = (ratio) => {
  const clamped = Math.max(0, Math.min(1, ratio));
  return Math.min(palette.length - 1, Math.floor(clamped * palette.length));
};

const computeAggregate = () => {
  const total = cards.length || 1;
  let hot = 0;
  cards.forEach((c) => {
    if ((c.dataset.liveMood || c.dataset.mood) === "hot") hot += 1;
  });
  return { hot, total, ratio: hot / total };
};

const updateGlobalMeter = () => {
  if (!page) return;
  const { hot, total, ratio } = computeAggregate();
  const percent = Math.round(ratio * 100);
  const step = stepForRatio(ratio);
  page.dataset.meterStep = String(step);
  page.dataset.pageMood = ratio >= 0.5 ? "hot" : "cold";
  document.documentElement.style.setProperty("--mood-bg", palette[step]);
  document.documentElement.style.setProperty(
    "--mood-strong",
    ratio >= 0.5 ? "#e03a3a" : "#27a2e5",
  );
  if (meterFill) meterFill.style.width = `${percent}%`;
  const facePos = Math.min(100, Math.max(0, percent));
  if (meterFace) {
    meterFace.style.left = `${facePos}%`;
    meterFace.classList.toggle("face-crop--hot", ratio >= 0.5);
    meterFace.classList.toggle("face-crop--cold", ratio < 0.5);
  }
  if (meterBalloon) {
    const labels = [
      "スイッチを押してみよう!",
      "いいね、その調子!",
      "もう少しで全部ほっと!",
      "全部ほっと！やったね",
    ];
    let label = labels[0];
    if (ratio === 1) label = labels[3];
    else if (ratio >= 0.66) label = labels[2];
    else if (ratio >= 0.16) label = labels[1];
    meterBalloon.textContent = label;
  }
  if (globalMeter) {
    globalMeter.dataset.count = `${hot}/${total}`;
  }
  // side-guide の台詞は refreshSideGuide (セクション/段階連動) が管理するため、
  // ここでのグローバル比率フォールバックは廃止。
};

/* === side-switch-guide: セクション/クリック連動の演出 ===
 - セクションごとに台詞を切替 (IntersectionObserver)
 - トグルクリックで台詞をランダム/ローテーション (3.5s 後にセクション台詞に復帰) */
const sideGuideMessages = {
  // セクション台詞 (data-guide-section 属性で識別)
  section: {
    kv: { face: "hiyari", text: `スイッチをクリックして<b>ほっとを集めよう！</b>` },
    about: { face: "hiyari", text: `おうちの<b>ひやり</b>、見つけてみよう` },
    lock: { face: "hiyari", text: `鍵で<b>ひやり</b>を、<b>ほっと</b>に変えよう` },
    "product-lock": { face: "hotto", text: `これがあれば<b>毎日が安心</b>！` },
    remote: { face: "hiyari", text: `リモコンの<b>ひやり</b>もまるっと<b>ほっと</b>に` },
    "product-remote": { face: "hotto", text: `<b>家中スマート</b>でほっと` },
    movie: { face: "hotto", text: `みんなの<b>ほっと</b>な瞬間、見てみよう` },
    campaign: { face: "hotto", text: `<b>豪華賞品</b>が当たるチャンス！` },
    future: { face: "hotto", text: `未来のおうちは<b>もっとほっと</b>` },
  },
};

// 段階セリフ (0〜6段階)。段階 = そのエリアのほっと枚数 (1枚=1段階)。
// 段階0は男女とも「スイッチを押して、ほっとしよう！」。
const sideGuideStagePhrases = {
  female: [
    `スイッチを押して、<b>ほっとしよう！</b>`,
    `<b>いいねぇ！</b>`,
    `<b>ほっとする～</b>`,
    `<b>楽チン楽チン♪</b>`,
    `<b>もーっと、ほっと！</b>`,
    `<b>もっと、もーっと、ほっと！</b>`,
    `<b>ふ～っ、ほっとしたね～</b>`,
  ],
  male: [
    `スイッチを押して、<b>ほっとしよう！</b>`,
    `<b>いい感じ！</b>`,
    `<b>ほっとしますなぁ</b>`,
    `<b>安心安心♪</b>`,
    `<b>もっとほっとしたいなぁ</b>`,
    `<b>あと少し！</b>`,
    `<b>あ～ほっとした～</b>`,
  ],
};
// エリア → 性別: ロック=男性 / リモコン=女性
const sideGuideSectionGender = { lock: "male", remote: "female" };

// 現在の性別・段階 (変化検出用)
let sideGuideGender = "female";
let sideGuideStage = -1;

// 吹き出しテキスト + 色 (mood) を更新。重複呼び出しによる
// 「点滅 (2回 fade)」を防ぐため、(1) 同じ内容なら何もしない (2) 進行中の fade
// タイマーを cancel して上書き、の2段ガードを入れる。
let __sideGuideFadeTimer = null;
let __sideGuideLastText = null;
let __sideGuideLastMood = null;
const setSideGuideText = (text, face) => {
  const sideGuide = document.querySelector("[data-side-guide]");
  const sideText = document.querySelector("[data-side-text]");
  if (!sideText || !sideGuide) return;
  const wantedText = String(text);
  const wantedMood = face || "hotto";
  // 同じテキスト & 同じ mood なら再 fade しない (連続呼び出しでも点滅しない)
  if (wantedText === __sideGuideLastText && wantedMood === __sideGuideLastMood) return;
  __sideGuideLastText = wantedText;
  __sideGuideLastMood = wantedMood;
  sideGuide.dataset.mood = wantedMood;
  if (__sideGuideFadeTimer) clearTimeout(__sideGuideFadeTimer);
  sideText.classList.add("is-fading");
  __sideGuideFadeTimer = setTimeout(() => {
    sideText.innerHTML = wantedText;
    sideText.classList.remove("is-fading");
    __sideGuideFadeTimer = null;
  }, 200);
};

// 6段階制に拡張。
// 性別 + 段階(0-6)を受け取り、段階に応じた画像をフレームにセット。
// - 段階 0-5: 1 枚ずつ表情変化 → frame--1/2/3 全てに同じ画像 (frame--1 だけ opacity:1)
// - 段階 6: 3 枚ループ → frame--1/2/3 に 6-1/6-2/6-3 をセット (CSS sideKoma1/2/3 でループ)
// 性別 or 段階が変わったら true を返す
const setSideGuideCharacter = (gender, stage) => {
  const faceEl = document.querySelector("[data-side-face]");
  const chars = window.__lpAssets && window.__lpAssets.sideGuideChars;
  const changed = gender !== sideGuideGender || stage !== sideGuideStage;
  sideGuideGender = gender;
  if (faceEl && chars) {
    const stageKey = String(stage);
    const stageFrames = (chars[gender] && chars[gender][stageKey]) || [];
    faceEl.querySelectorAll("[data-side-frame]").forEach((img, idx) => {
      // 段階6 (3フレーム配列) なら idx 番目を、段階0-5 (1枚) なら frames[0] を共通で使う
      const src = stageFrames[idx] || stageFrames[0] || "";
      if (src && img.src !== src) img.src = src;
    });
  }
  return changed;
};

// 「ファッと出る」ポップを再生 (段階/性別が変わった瞬間)
const playSideFacePop = () => {
  const faceEl = document.querySelector("[data-side-face]");
  if (!faceEl) return;
  faceEl.classList.remove("is-pop");
  void faceEl.offsetWidth; // reflow で animation 再起動
  faceEl.classList.add("is-pop");
};

// セクション内のほっとカード数
const countHotInSection = (sel) => {
  let n = 0;
  document.querySelectorAll(sel + " [data-case-card]").forEach((c) => {
    if ((c.dataset.liveMood || c.dataset.mood) === "hot") n += 1;
  });
  return n;
};

// 右下キャラを現在のセクション/段階に合わせて更新
// - ロック/リモコン: そのエリアのほっと枚数(0〜6)で段階。段階6でコマアニメ+もくもく(双方向)
// - その他セクション: 従来のセクション台詞、完了演出は解除
const refreshSideGuide = () => {
  const guide = document.querySelector("[data-side-guide]");
  if (!guide) return;
  const key = window.__sideGuideSection;
  const gender = sideGuideSectionGender[key];
  if (gender) {
    const sel = key === "lock" ? ".experience--lock" : ".experience--remote";
    const stage = Math.min(6, countHotInSection(sel));
    const stageChanged = stage !== sideGuideStage;
    // 段階を渡して段階別画像をセット
    const genderChanged = setSideGuideCharacter(gender, stage);
    sideGuideStage = stage;
    // 段階0は青(ひやり)、1以上は赤(ほっと)
    setSideGuideText(
      sideGuideStagePhrases[gender][stage],
      stage === 0 ? "hiyari" : "hotto",
    );
    // 段階6 (そのエリア6枚ほっと) でコマアニメ+もくもく。双方向: 下がれば解除
    guide.classList.toggle("is-allhot", stage === 6);
    if (stageChanged || genderChanged) playSideFacePop();
    // スイッチ一覧(lock/remote)にいる間だけガイドを表示。
    page?.classList.add("is-switch-area");
  } else {
    guide.classList.remove("is-allhot");
    sideGuideStage = -1;
    const msg = key ? sideGuideMessages.section[key] : null;
    if (msg) setSideGuideText(msg.text, msg.face);
    // スイッチ一覧エリアを抜けたら(商品「SMART LOCK」等)フェードアウト。
    page?.classList.remove("is-switch-area");
  }
};

const initSideGuideSectionObserver = () => {
  const targets = Array.from(document.querySelectorAll("[data-guide-section]"));
  if (targets.length === 0) return;
  // viewport 中央に最も近いセクションを判定 (scroll ベース)
  const detectCurrent = () => {
    // セクション判定ラインを画面中央(50%)ではなく62%に置く。スクロールで体験
    // セクションを抜ける判定が早くなり、右下ガイドが「もう少し早め(上)」でフェード
    // アウトする(商品 SMART LOCK 説明への被りをより早く解消)。値を上げるほど早く消える。
    const centerY = window.innerHeight * 0.62;
    let bestKey = null;
    let bestDist = Infinity;
    for (const t of targets) {
      const r = t.getBoundingClientRect();
      // viewport を element が跨いでいるか
      if (r.top <= centerY && r.bottom >= centerY) {
        // 中央を含むセクション = 即採用 (最優先)
        bestKey = t.dataset.guideSection;
        bestDist = 0;
        break;
      }
      // 跨ぎがない場合: element 中央と viewport 中央の距離が最小のものを採用
      const elCenter = (r.top + r.bottom) / 2;
      const dist = Math.abs(elCenter - centerY);
      if (dist < bestDist) {
        bestDist = dist;
        bestKey = t.dataset.guideSection;
      }
    }
    if (!bestKey || bestKey === window.__sideGuideSection) return;
    window.__sideGuideSection = bestKey;
    refreshSideGuide();
  };
  let raf = null;
  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      detectCurrent();
    });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  detectCurrent(); // 初期化
};

const updateMood = (card, { fromUser = false } = {}) => {
  if (!page || !card) return;
  const isHot = (card.dataset.liveMood || card.dataset.mood) === "hot";
  card.classList.toggle("is-hot", isHot);
  updateGlobalMeter();
  // updateAreaMood は user 操作 (click/drag) 起点のときだけ。
  // スクロール時の IntersectionObserver からは呼ばない (bg pink フラッシュ防止)
  if (fromUser && typeof updateAreaMood === "function") updateAreaMood(card);
  // 操作のたびに右下キャラの段階(エリアのほっと枚数)を更新
  if (fromUser) refreshSideGuide();
};

const flashToggleLabel = (label) => {
  if (!label) return;
  label.classList.remove("is-hidden", "is-visible");
  void label.offsetWidth;
  label.classList.add("is-visible");
  window.setTimeout(() => {
    label.classList.remove("is-visible");
    label.classList.add("is-hidden");
  }, 1200);
};

const setSwitchState = (toggle, on, { flash = true, syncMood = true } = {}) => {
  const card = toggle.closest("[data-case-card]");
  const knob = toggle.querySelector(".hiyari-toggle__knob");
  const bgOff = toggle.querySelector(".hiyari-toggle__bg--off");
  const faceOn = toggle.querySelector(".hiyari-toggle__face--on");
  const faceOff = toggle.querySelector(".hiyari-toggle__face--off");
  const labelOn = toggle.querySelector(".hiyari-toggle__label--on");
  const labelOff = toggle.querySelector(".hiyari-toggle__label--off");
  toggle.setAttribute("aria-pressed", String(on));
  toggle.dataset.on = on ? "true" : "false";
  // transform 化に伴い、knob の位置制御は CSS の
  // `[aria-pressed="true"]` rule に一本化。ここでは drag 中に設定された
  // inline transform を解除して CSS 制御に戻す (transition でスムーズに animate)。
  knob.style.transform = "";
  bgOff.style.opacity = on ? 0 : 1;
  faceOn.style.opacity = on ? 1 : 0;
  faceOff.style.opacity = on ? 0 : 1;
  card?.classList.toggle("is-hot", on);
  if (syncMood) {
    card?.setAttribute("data-live-mood", on ? "hot" : "cold");
    // user 操作 (toggle click/drag) 起点だけ updateAreaMood を発火
    if (card) updateMood(card, { fromUser: flash });
  }
  if (flash) flashToggleLabel(on ? labelOn : labelOff);
  if (navigator.vibrate) navigator.vibrate(10);
  // side-guide の段階更新は updateMood → refreshSideGuide で行う (ひやり/ほっと両方で再計算)
  /* HOT 切替時のお祝い演出: 5 つの "ほっと" 装飾を時間差で flash
   最終 red-br は delay 420ms + 1.4s = 1.82s で完了。
   race condition fix: 前回 timeout を clear して on/off 連打でも崩れないように */
  if (flash && on) {
    if (toggle._hotFlashTimer) {
      clearTimeout(toggle._hotFlashTimer);
      toggle._hotFlashTimer = null;
    }
    toggle.classList.remove("is-hot-flash");
    /* reflow して animation を再起動 */
    void toggle.offsetWidth;
    toggle.classList.add("is-hot-flash");
    toggle._hotFlashTimer = setTimeout(() => {
      toggle.classList.remove("is-hot-flash");
      toggle._hotFlashTimer = null;
    }, 2000);
  } else if (!on) {
    /* off に戻したら hot-flash も即座に解除 */
    if (toggle._hotFlashTimer) {
      clearTimeout(toggle._hotFlashTimer);
      toggle._hotFlashTimer = null;
    }
    toggle.classList.remove("is-hot-flash");
  }
};

const initHiyariToggles = () => {
  document.querySelectorAll(".hiyari-toggle").forEach((toggle) => {
    const knob = toggle.querySelector(".hiyari-toggle__knob");
    const bgOff = toggle.querySelector(".hiyari-toggle__bg--off");
    const faceOn = toggle.querySelector(".hiyari-toggle__face--on");
    const faceOff = toggle.querySelector(".hiyari-toggle__face--off");
    let dragging = false;
    let moved = false;
    let suppressClick = false;
    let startX = 0;
    let startLeft = 0;
    /* drag 中の現在位置 (px)。transform 化により knob.offsetLeft では
       追えなくなったので JS state で持つ。drag-end の snap 判定に使う。 */
    let dragLeftPx = 0;
    const maxLeft = () => toggle.offsetWidth - knob.offsetWidth;
    const pointX = (event) => event.touches?.[0]?.clientX ?? event.clientX;

    const down = (event) => {
      event.preventDefault();
      dragging = true;
      moved = false;
      startX = pointX(event);
      /* 現状態 (aria-pressed/dataset.on) から logical な startLeft を算出。
         on=true → 右端 (maxLeft)、off → 左端 (0)。 */
      startLeft = toggle.dataset.on === "true" ? maxLeft() : 0;
      dragLeftPx = startLeft;
      knob.classList.add("is-dragging");
      bgOff.style.transition = "none";
    };

    const move = (event) => {
      if (!dragging) return;
      const dx = pointX(event) - startX;
      /* タップ許容を 3→10px に拡大。タップ時の微ブレ(指/マウスの数px移動)が
         "ドラッグ"扱いになり、ON位置から動かず元に戻る(ひやりに戻らない)問題への対処。
         10px 超の明確なドラッグのみ snap 判定に回す。 */
      if (Math.abs(dx) > 10) moved = true;
      if (!moved) return;
      event.preventDefault();
      const max = maxLeft();
      const nextLeft = Math.max(0, Math.min(max, startLeft + dx));
      dragLeftPx = nextLeft;
      const progress = max ? nextLeft / max : 0;
      /* left → transform。is-dragging 中は transition: none なので即時反映。 */
      knob.style.transform = `translateX(${nextLeft}px)`;
      bgOff.style.opacity = 1 - progress;
      faceOn.style.opacity = progress;
      faceOff.style.opacity = 1 - progress;
    };

    const up = () => {
      if (!dragging) return;
      dragging = false;
      knob.classList.remove("is-dragging");
      bgOff.style.transition = "opacity 0.5s";
      /* knob 操作(tap/drag)で状態を確定したら、直後に発火する native click を 1 回だけ
         無効化する。トグル切替で knob が cursor 下からスライドし click target が button に
         なるため、click ハンドラの knob.contains(target) 除外をすり抜けて再トグル
         (二重トグルで元に戻る) してしまう問題への対処。track クリック時は down() が
         発火せず dragging=false でこの up は即 return するため影響しない。 */
      suppressClick = true;
      setTimeout(() => {
        suppressClick = false;
      }, 0);
      /* iPhone 実機では指タップが必ず数px横にブレる。move() が >10px のブレを
         moved=true (ドラッグ扱い) にすると、cold→hot タップは開始位置が左端(0)のため
         位置スナップ(>0.4)に届かず OFF に戻り「ヒヤリからほっとに切り替わらない」状態に
         なる。実移動量(travel)が track 幅の半分未満なら指ブレを含むタップとみなして
         状態を反転し、半分以上の明確なドラッグのみ位置スナップで確定する。 */
      const travel = Math.abs(dragLeftPx - startLeft);
      if (!moved || travel < maxLeft() * 0.5) {
        setSwitchState(toggle, toggle.dataset.on !== "true");
        return;
      }
      /* knob.offsetLeft ではなく dragLeftPx (state) で判定 */
      setSwitchState(toggle, dragLeftPx / maxLeft() > 0.4);
    };

    knob.addEventListener("mousedown", down);
    knob.addEventListener("touchstart", down, { passive: false });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    toggle.addEventListener("click", (event) => {
      if (suppressClick || knob.contains(event.target) || moved) return;
      setSwitchState(toggle, toggle.dataset.on !== "true");
    });

    // 全トグルを初期 OFF (HIYARI) で固定
    setSwitchState(toggle, false, { flash: false, syncMood: false });
  });
};

const inViewMap = new Map();
const switchAreaObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      inViewMap.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0.15);
      entry.target.classList.toggle(
        "is-in-view",
        entry.isIntersecting && entry.intersectionRatio > 0.15,
      );
    });
    // ガイドの表示/非表示は refreshSideGuide(セクション中央判定)に一本化。
    // 旧: 縦長 case-list が 15% でも見えると is-switch-area=true になり、商品
    //     「SMART LOCK」まで被っていた。observer 側の is-switch-area トグルは撤去。
  },
  { rootMargin: "-140px 0px -140px 0px", threshold: [0, 0.15, 0.5, 1] },
);

switchAreas.forEach((area) => switchAreaObserver.observe(area));

const updateSwitchAreaVisibility = () => {
  // ガイド表示は refreshSideGuide(セクション判定)に一本化したため no-op 化。
  // (互換のため関数自体は残す)
};

const observer = new IntersectionObserver(
  (entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
    if (visible[0]) updateMood(visible[0].target);
  },
  { rootMargin: "-20% 0px -45% 0px", threshold: [0.3, 0.55, 0.8] },
);

// initHiyariToggles を先に呼ぶ (内部で setSwitchState(false) を全 toggle に対して行うため)。
// その後、cards.forEach で data-mood="hot" のカードに is-hot を再設定する。
initHiyariToggles();

cards.forEach((card) => {
  // 初期 mood は data-mood (markup の card.mood で渡された値) に従う。
  // hot のカードは赤背景 + ほっと見せでスタート。
  const initialMood = card.dataset.mood || "cold";
  const isHot = initialMood === "hot";
  card.setAttribute("data-live-mood", initialMood);
  card.classList.toggle("is-hot", isHot);
  // hot で初期化された card は toggle UI も on 状態に同期 (PC で表示する toggle のため)
  if (isHot) {
    const toggle = card.querySelector(".hiyari-toggle");
    if (toggle) {
      toggle.setAttribute("aria-pressed", "true");
      toggle.dataset.on = "true";
      // knob 位置は CSS の `[aria-pressed="true"]` rule で制御するので
      // ここで explicit に position を設定する必要なし。
    }
  }
  observer.observe(card);

  // SP では hiyari-toggle が hide されるため、visual エリアのクリックで is-hot を切替
  const visual = card.querySelector(".case-card__visual");
  if (visual) {
    visual.addEventListener("click", (e) => {
      if (e.target.closest(".hiyari-toggle")) return;
      const willHot = !card.classList.contains("is-hot");
      card.classList.toggle("is-hot", willHot);
      card.setAttribute("data-live-mood", willHot ? "hot" : "cold");
      updateMood(card, { fromUser: true });
      if (navigator.vibrate) navigator.vibrate(10);
    });
  }
});

// スマートロック/リモコン背景。
// hot クリック → pink にして 350ms 後に gray へ早めに戻る (タップ feedback)。
// cold クリック → gray にそのまま直行。
// transition (220ms) + 350ms 後 revert = 計 600ms の自然な feedback サイクル。
const lockCardsForBg = document.querySelectorAll(".experience--lock [data-case-card]");
const remoteCardsForBg = document.querySelectorAll(".experience--remote [data-case-card]");
const moodResetTimers = { "--lock-mood-bg": null, "--remote-mood-bg": null };
const updateAreaMood = (triggerCard) => {
  const root = document.documentElement;
  if (!triggerCard) {
    // 初期: 全 cold = gray
    root.style.setProperty("--lock-mood-bg", "#e9e9e9");
    root.style.setProperty("--remote-mood-bg", "#e9e9e9");
    return;
  }
  const section = triggerCard.closest(".experience--lock, .experience--remote");
  if (!section) return;
  const isLock = section.classList.contains("experience--lock");
  const varName = isLock ? "--lock-mood-bg" : "--remote-mood-bg";
  const cards = isLock ? lockCardsForBg : remoteCardsForBg;
  const isHot = (triggerCard.dataset.liveMood || triggerCard.dataset.mood) === "hot";
  // セクション内の全カードが hot かどうか判定
  const allHot =
    cards.length > 0 &&
    Array.from(cards).every(
      (c) => (c.dataset.liveMood || c.dataset.mood) === "hot",
    );
  // 既存のタイマーがあればキャンセル
  if (moodResetTimers[varName]) clearTimeout(moodResetTimers[varName]);
  if (allHot) {
    // 全てほっと → #FFD7D7 で固定 (タイマーで戻さない)
    root.style.setProperty(varName, "#ffd7d7");
  } else if (isHot) {
    // hot クリックだが全部ではない → pink にしてから gray へ戻る (タップ feedback)。
    // 戻りが早すぎないよう 1600ms に設定。
    root.style.setProperty(varName, "#ffd7d7");
    moodResetTimers[varName] = window.setTimeout(() => {
      root.style.setProperty(varName, "#e9e9e9");
      moodResetTimers[varName] = null;
    }, 1600);
  } else {
    // cold: そのまま gray (全ほっと固定が解除されたケースもここで gray に戻る)
    root.style.setProperty(varName, "#e9e9e9");
  }
};

updateGlobalMeter();
updateAreaMood();
updateSwitchAreaVisibility();
setSideGuideCharacter("female"); // 非カードセクションでも初期フレームが空にならないように
initSideGuideSectionObserver();

/* movie facade: クリックで video modal を開いて YouTube iframe を再生
 (Figma node 2154-13429 の動画モーダルデザイン準拠) */
const videoModal = document.querySelector(".video-modal");
const videoPlayer = videoModal?.querySelector("[data-video-player]");
const openVideoModal = (id) => {
  if (!videoModal || !videoPlayer) return;
  videoPlayer.innerHTML = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1" title="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
  videoModal.hidden = false;
  videoModal.setAttribute("aria-hidden", "false");
  requestAnimationFrame(() => videoModal.classList.add("is-open"));
  document.body.classList.add("is-video-open");
  document.body.style.overflow = "hidden";
};
const closeVideoModal = () => {
  if (!videoModal || !videoPlayer) return;
  videoModal.classList.remove("is-open");
  videoModal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("is-video-open");
  document.body.style.overflow = "";
  setTimeout(() => {
    videoPlayer.innerHTML = "";
    videoModal.hidden = true;
  }, 280);
};
document.querySelectorAll(".movie__card[data-youtube]").forEach((card) => {
  card.addEventListener("click", (e) => {
    e.preventDefault();
    openVideoModal(card.dataset.youtube);
  });
});
videoModal?.querySelectorAll("[data-video-close]").forEach((btn) => {
  btn.addEventListener("click", closeVideoModal);
});
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && videoModal?.classList.contains("is-open")) closeVideoModal();
});
window.addEventListener("scroll", updateSwitchAreaVisibility, { passive: true });
window.addEventListener("resize", updateSwitchAreaVisibility);

/* === 応募規約カード: カスタムスクロールバー (macOS overlay 回避) ===
 .campaign__terms-scroll のスクロール状態を .campaign__terms-thumb の top/height に同期 */
const initTermsScrollbar = () => {
  const scroll = document.querySelector("[data-terms-scroll]");
  const thumb = document.querySelector("[data-terms-thumb]");
  if (!scroll || !thumb) return;
  const update = () => {
    const { scrollTop, scrollHeight, clientHeight } = scroll;
    if (scrollHeight <= clientHeight) {
      thumb.style.opacity = "0";
      return;
    }
    thumb.style.opacity = "1";
    const ratio = clientHeight / scrollHeight;
    const thumbPct = Math.max(15, ratio * 100);
    const scrollPct =
      scrollHeight - clientHeight > 0
        ? (scrollTop / (scrollHeight - clientHeight)) * (100 - thumbPct)
        : 0;
    thumb.style.height = thumbPct + "%";
    thumb.style.top = scrollPct + "%";
  };
  scroll.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  /* 初回 + 画像 / フォントロード後にも一回 (scrollHeight が変わる可能性に備え) */
  update();
  requestAnimationFrame(update);
  setTimeout(update, 500);
};
initTermsScrollbar();

/* === KV カルーセル (Figma node 2204-14724 準拠) ===
 5 スライドを左→右 auto-advance。snap (グイン) transition。
 一時停止ボタンで停止/再開。 */
const initKvCarousel = () => {
  const kv = document.querySelector("[data-kv-carousel]");
  if (!kv) return;
  /* pause 削除 + .kv__progress (dots/arrows) は
     .kv-wrap 直下 (= .kv の外) に出してある。dots/arrows のクエリは
     wrap 配下を見ること (kv.querySelector では取れない)。 */
  const wrap = kv.closest(".kv-wrap") || kv;
  const track = kv.querySelector("[data-kv-track]");
  const dotsContainer = wrap.querySelector("[data-kv-dots]");
  const dotButtons = dotsContainer ? Array.from(dotsContainer.querySelectorAll(".kv__dot")) : [];
  const prevBtn = wrap.querySelector("[data-kv-prev]");
  const nextBtn = wrap.querySelector("[data-kv-next]");
  // 実スライド (data-slide-index 付き) と クローン (data-slide-clone 付き) を分ける
  const realSlides = kv.querySelectorAll(".kv__slide-item[data-slide-index]");
  const REAL_COUNT = realSlides.length; // 5
  if (REAL_COUNT < 2) return;
  const DWELL = 4000;
  // バーアニメ時間を CSS 変数で keyframe へ渡す (root に set してドットすべて参照可)
  kv.style.setProperty("--kv-dwell", `${DWELL}ms`);
  // track-index 1..REAL_COUNT が実スライド。0=clone#last、REAL_COUNT+1..=clone#first..
  let index = 1; // 実スライド #1 = track-index 1
  let timerId = null;
  const paused = false; // pause button 廃止後は常に false (auto-play 継続)
  const TRANSITION_MS = 480;

  // 進捗バーをスライド切替ごとに頭から再生 (active なドットの fill を re-trigger)
  const restartFill = () => {
    const activeDot = dotsContainer?.querySelector(".kv__dot.is-active .kv__dot-fill");
    if (!activeDot) return;
    activeDot.style.animation = "none";
    void activeDot.offsetWidth; // 強制リフロー
    activeDot.style.animation = "";
  };

  // active ドットを更新 + aria
  const updateLabelsAndAria = () => {
    const realIdx = ((index - 1 + REAL_COUNT) % REAL_COUNT); // 0..4
    dotButtons.forEach((dot, i) => {
      const isActive = i === realIdx;
      dot.classList.toggle("is-active", isActive);
      if (isActive) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
    realSlides.forEach((s, i) =>
      s.setAttribute("aria-hidden", i + 1 === index ? "false" : "true"),
    );
  };

  const apply = () => {
    if (track) track.style.setProperty("--kv-index", String(index));
    updateLabelsAndAria();
    restartFill();
  };
  // ループ時のスナップ: transition を一瞬切って track をジャンプするが、
  // fill アニメは再起動しない (再起動すると最終スライド終端 → 先頭にバーがガクッと戻って見える)
  const snapTo = (newIndex) => {
    if (!track) return;
    track.classList.add("is-snapping");
    index = newIndex;
    track.style.setProperty("--kv-index", String(index));
    void track.offsetWidth;
    track.classList.remove("is-snapping");
    updateLabelsAndAria();
    // NOTE: restartFill() は呼ばない → バーはそのまま継続
  };
  const next = () => {
    index += 1;
    apply();
    // track-index REAL_COUNT+1 = clone#first 表示中。transition 終了後に実 #1 へスナップ
    if (index === REAL_COUNT + 1) {
      window.setTimeout(() => snapTo(1), TRANSITION_MS + 20);
    }
  };
  const start = () => {
    if (paused || timerId) return;
    timerId = window.setInterval(next, DWELL);
    kv.dataset.paused = "false";
  };
  const stop = () => {
    if (timerId) {
      window.clearInterval(timerId);
      timerId = null;
    }
  };
  /* togglePause / pauseBtn 削除済 */

  // 前へ / 次へ
  const prev = () => {
    index -= 1;
    apply();
    // 0 = clone#last 表示中 → 実 #REAL_COUNT にスナップ
    if (index === 0) {
      window.setTimeout(() => snapTo(REAL_COUNT), TRANSITION_MS + 20);
    }
    stop();
    if (!paused) start();
  };
  prevBtn?.addEventListener("click", prev);
  nextBtn?.addEventListener("click", () => {
    next();
    stop();
    if (!paused) start();
  });

  // dot ボタンで該当スライドへジャンプ
  wrap.querySelectorAll("[data-kv-jump]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = parseInt(btn.dataset.kvJump || "0", 10);
      if (Number.isNaN(target) || target < 0 || target >= REAL_COUNT) return;
      // track-index は real index + 1
      index = target + 1;
      apply();
      stop();
      if (!paused) start();
    });
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stop();
    else if (!paused) start();
  });

  apply();
  start();

  /* kvFloating JS は撤去。
     slider の動的追従は CSS `position: sticky; bottom: 12px` で代替 (.kv__progress)。
     これで KV が食われ中は viewport 下端に貼り付き、白ストリップに到達したら
     自然位置に settle、KV を過ぎたら一緒に流れる。 */
};
initKvCarousel();

/* ハンバーガーメニュー (SP のみ表示) */
const initSpMenu = () => {
  const trigger = document.querySelector(".header__hamburger");
  const overlay = document.querySelector(".sp-menu");
  const closeBtn = overlay?.querySelector(".sp-menu__close");
  if (!trigger || !overlay) return;
  const open = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add("is-open"));
    trigger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    overlay.classList.remove("is-open");
    trigger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    /* CSS slide-out transition (transform 380ms) を待ってから hidden を付与 */
    setTimeout(() => {
      overlay.hidden = true;
    }, 420);
  };
  trigger.addEventListener("click", () => {
    if (overlay.hidden) open();
    else close();
  });
  closeBtn?.addEventListener("click", close);
  overlay
    .querySelectorAll("[data-sp-menu-link]")
    .forEach((a) => a.addEventListener("click", close));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !overlay.hidden) close();
  });
};
initSpMenu();

window.setTimeout(() => {
  const target = window.location.hash ? document.querySelector(window.location.hash) : null;
  if (target) {
    target.scrollIntoView({ block: "start" });
    window.requestAnimationFrame(updateSwitchAreaVisibility);
  }
}, 0);

// キャンペーン顔バンドの末尾見切れ防止
// セクション高さに入りきらない .cface に .cface--clipped を付与して display:none
const tuneCampaignFaces = () => {
  document.querySelectorAll("[data-campaign-faces]").forEach((box) => {
    const containerH = box.clientHeight;
    const faces = box.querySelectorAll(".cface");
    // フェイルセーフ: コンテナが顔1つ分の高さにも満たない異常計測時
    // (レイアウト未確定/Edge計測差等) はクリップしない。overflow:hidden が
    // 視覚的な見切れを担保するため、未クリップでも崩れず「全消し」事故を防ぐ。
    const faceH = faces[0] ? faces[0].offsetHeight : 0;
    if (!containerH || !faceH || containerH < faceH) {
      faces.forEach((face) => face.classList.remove("cface--clipped"));
      return;
    }
    faces.forEach((face) => {
      face.classList.remove("cface--clipped");
      if (face.offsetTop + face.offsetHeight > containerH + 1) {
        face.classList.add("cface--clipped");
      }
    });
  });
};
tuneCampaignFaces();
window.addEventListener("load", tuneCampaignFaces);
let __faceResizeTid = 0;
window.addEventListener("resize", () => {
  clearTimeout(__faceResizeTid);
  __faceResizeTid = window.setTimeout(tuneCampaignFaces, 100);
});

/* キャンペーン「今すぐ応募」ボタンを Omnisend カスタムフォームに連結。
   クラス名 `myCutsomOpenCustomForm` は外部フォーム連携の仕様に合わせた名前
   (typo に見えるが変更不可) — フォーム側と一致させる必要あり。 */
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".myCutsomOpenCustomForm");
  if (!btn) return;
  e.preventDefault();
  window.omnisend = window.omnisend || [];
  window.omnisend.push(["openForm", "6a141b2e27bba0dc23323dea"]);
});

  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
